import { useState, useEffect } from 'react';

export const useTextScramble = (text, isActive, speed = 30) => {
  const [displayText, setDisplayText] = useState('');
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&*';

  useEffect(() => {
    if (!isActive) {
      setDisplayText('');
      return;
    }

    let iteration = 0;
    const maxIterations = text.length * 3;

    const interval = setInterval(() => {
      setDisplayText(
        text.split('').map((char, index) => {
          if (char === ' ') return ' ';
          if (index < iteration / 3) return text[index];
          return chars[Math.floor(Math.random() * chars.length)];
        }).join('')
      );

      iteration++;

      if (iteration >= maxIterations) {
        setDisplayText(text);
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, isActive, speed]);

  return displayText;
};
